import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import noItems from '@assets/icons/no-results.svg';
import messages from '../messages';

const Container = styled.span`
  padding: ${({ theme }) => theme.spacing(12, 0, 12, 0)};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const Icon = styled.img`
  height: 100px;
  width: 100px;
`;

const Text = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.mediumSemiBold}
`;

function EmptyCart() {
  return (
    <Container>
      <Icon src={noItems} aria-hidden="true" />
      <Text>
        <FormattedMessage {...messages.emptyCart} />
      </Text>
    </Container>
  );
}

export default EmptyCart;
